import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, getId, createItem, updateItem, deleteById } from "./branchAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "branch/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchBranch = createAsyncThunk(
  "branch/fetchBranch",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("branch/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdNoloading = createAsyncThunk(
  "branch/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("branch/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("branch/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "branch/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchBranch.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = branchSlice.actions;

export const selectData = (state) => state.branch.data;
export const selectBranch = (state) => state.branch.data;
export const selectId = (state) => state.branch.dataId;
export const selectLoading = (state) => state.branch.loading;
export const selectError = (state) => state.branch.error;
export const selectPageNo = (state) => state.branch.pageNo;
export const selectPageSize = (state) => state.branch.pageSize;
export const selectTotalRecord = (state) => state.branch.totalRecord;
export const selectSelected = (state) => state.branch.selected;
export const selectResult = (state) => state.branch.result;

export default branchSlice.reducer;
